import Languages from './Languages.js'

type PriceExplanationColliType = {
    type?: string
    nrOfColli?: number
    nrOfColliIncluded?: number
}

// The colli totaal line of the price explanation, e.g. 'Doos (2x), Pallet (1x), 1 inbegrepen'. nrOfColli only counts the
// charged colli, so a colli type whose colli are all included is only mentioned in the included count.
export function getColliTypesSummary(colliTypes: PriceExplanationColliType[] = []) {
    const nrOfColliIncluded = colliTypes.reduce((sum, colliType) => sum + (colliType.nrOfColliIncluded || 0), 0)

    return [
        ...colliTypes.filter((colliType) => colliType.nrOfColli > 0).map((colliType) => `${colliType.type} (${colliType.nrOfColli}x)`),
        ...(nrOfColliIncluded > 0 ? [Languages.priceExplanationColliIncluded.NL(nrOfColliIncluded)] : [])
    ].join(', ')
}

// Per collo (by colli type name, in order) whether it is included: the first nrOfColliIncluded colli of each type
export function getIncludedColli(colliTypeNames: string[], colliTypes: PriceExplanationColliType[] = []) {
    const remainingIncluded: Record<string, number> = {}

    colliTypes.forEach((colliType) => {
        remainingIncluded[colliType.type] = (remainingIncluded[colliType.type] || 0) + (colliType.nrOfColliIncluded || 0)
    })

    return colliTypeNames.map((colliTypeName) => {
        if (!remainingIncluded[colliTypeName]) return false

        remainingIncluded[colliTypeName]--

        return true
    })
}
